export function getClientEnv() {
	return {
		VITE_API_URL: import.meta.env.VITE_API_URL || "http://mst.lc",
	};
}
